import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrUnitType.ts
var t = () => e("unitType");
//#endregion
export { t as useTrUnitType };
